// extracted by mini-css-extract-plugin
module.exports = {"mobileAccordionContainer":"MobileAccordionContainer-module__mobileAccordionContainer___w9EV5"};